import { render, staticRenderFns } from "./GlobalNotificationCard.vue?vue&type=template&id=63728b3a&scoped=true&"
import script from "./GlobalNotificationCard.vue?vue&type=script&lang=js&"
export * from "./GlobalNotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotificationCard.vue?vue&type=style&index=0&id=63728b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63728b3a",
  null
  
)

export default component.exports